import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import IntegrationBreadcrumb from 'components/Integration/components/IntegrationBreadcrumb'
import { orgUsersById } from 'app/modules/user/selectors'
import { fetchHubspotUserMappings, patchHubspotUserMappings, searchHubspotUsers } from 'app/modules/hubspot/actions'
import { getUserMappings, getHubspotUsers, isUserMappingLoading, isUserMappingLoaded, isHubspotUsersSearchLoading } from 'app/modules/hubspot/selectors'
import { HubspotUserMap } from 'app/modules/hubspot/models'
import { fetchOrgUsers } from 'app/modules/user/actions'
import OwnerMapper from '../../components/OwnerMapper'
import { Loader } from '@driftt/tide-core-legacy'

import './style.styl'

class HubspotUserMapping extends Component {

  componentDidMount() {
    this.props.actions.fetchOrgUsers()
    if (!this.props.isMappingLoaded && !this.props.isMappingLoading) {
      this.props.actions.fetchHubspotUserMappings()
    }
  }

  render() {
    const { isMappingLoaded, userMappings, driftUsers, hubspotUsers, actions, isSearching } = this.props
    return (
      <div className="integration-user-mapping common-integration-page-layout">
        <IntegrationBreadcrumb
          backLinkText="Hubspot Integration"
          backLinkUrl="/settings/setup/hubspot"
        />      
        <header>
          <h2 className="integration-header">Mapped Hubspot Users</h2>
          <p>Map your Drift Teammates to your Hubspot Teammates or invite them to join the family!</p>
        </header>

        { !isMappingLoaded
          ? (
            <Loader className="loader-position"/>
          ) : (
            <OwnerMapper
              integrationName="Hubspot"
              mappings={userMappings}
              driftUsers={driftUsers}
              integrationUsers={hubspotUsers}
              isSearching={isSearching}      
              userMappingModel={HubspotUserMap}
              patchMappings={actions.patchHubspotUserMappings}
              searchIntegrationUsers={actions.searchHubspotUsers}
              fetchOrgUsers={actions.fetchOrgUsers}
            />
          )        
        }
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    driftUsers: orgUsersById(state).toJS(),
    userMappings: getUserMappings(state),
    hubspotUsers: getHubspotUsers(state),
    isMappingLoading: isUserMappingLoading(state),
    isMappingLoaded: isUserMappingLoaded(state),
    isSearching: isHubspotUsersSearchLoading(state)
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      fetchOrgUsers,
      fetchHubspotUserMappings,
      searchHubspotUsers,
      patchHubspotUserMappings
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HubspotUserMapping)



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/HubspotUserMapping/index.js